import { render } from "./CriminalHistory.vue?vue&type=template&id=37468bd4&ts=true"
import script from "./CriminalHistory.vue?vue&type=script&lang=ts"
export * from "./CriminalHistory.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__